export default "/images/dca1525b054dda992d99df16adf30940.avif";